let playHistory = window.localStorage.getItem('playHistory')

try {
  playHistory = JSON.parse(playHistory) || []
} catch (error) {
  playHistory = []
}

export default {
  namespaced: true,
  state: {
    playHistory
  },

  mutations: {
    setPlayHistory(state, payload) {
      state.playHistory = payload
    },
  },

  actions: {
    addPlayHistory({ commit, state }, payload) {
      if (!payload) return
      
      const index = state.playHistory.findIndex(item => item.bookId === payload.bookId)
      if (index !== -1) {
        state.playHistory.splice(index, 1)
      }

      state.playHistory.unshift(payload)
      window.localStorage.setItem('playHistory', JSON.stringify(state.playHistory.slice(0, 5)))
      commit('setPlayHistory', state.playHistory)
    },

    clearPlayHistory({ commit }) {
      window.localStorage.removeItem('playHistory')
      commit('setPlayHistory', [])
    }
  }
}

